module.exports = require('../dist/contexts/CitationContext');
